export default {
	text: 'Les informations ci-dessus ne sont pas exhaustives. En fonction de l\'état de santé de votre enfant, votre médecin peut être amené à lui prescrire d\'autres examens. En cas de doute, n\'hésitez pas à consulter votre médecin.'
};
